const comunicacionInternaEnumerators = {
  estado: [
    'Abierta',
    'Cerrada',
  ],
};

export default comunicacionInternaEnumerators;
